export const isFilterActive = (currentPath, targetUrl, filterKey, filterValue) => {
  const url = new URL(targetUrl, window.location.origin);

  const normalize = (path) => path.replace(/^\/|\/$/g, '');

  const pathMatches = normalize(currentPath).startsWith(normalize(url.pathname));
  const filterMatches = url.searchParams.get(filterKey) === filterValue;

  return pathMatches && filterMatches;
};
